import { render } from "./CampaignCreate.vue?vue&type=template&id=97bd4c5e&scoped=true"
import script from "./CampaignCreate.vue?vue&type=script&lang=js"
export * from "./CampaignCreate.vue?vue&type=script&lang=js"

import "./CampaignCreate.vue?vue&type=style&index=0&id=97bd4c5e&lang=scss&scoped=true"

import exportComponent from "/builds/retina-v5/principal-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97bd4c5e"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QForm from 'quasar/src/components/form/QForm.js';
import QStepper from 'quasar/src/components/stepper/QStepper.js';
import QStep from 'quasar/src/components/stepper/QStep.js';
import QRadio from 'quasar/src/components/radio/QRadio.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon,QForm,QStepper,QStep,QRadio,QList,QItem,QItemSection,QItemLabel,QSeparator});
